import { MemberStatus } from '@prisma/client';
import { PermissionProvider } from 'react-permission-role';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './auth-provider';
import { useInvitations } from './modules/invitations/hooks/useInvitations';

// Extract invitation check logic into a separate component
function ProtectedContent() {
  const { data: invitations, isLoading: isLoadingInvitations } = useInvitations();

  if (isLoadingInvitations) {
    return null;
  }

  // Check for pending invitations
  const pendingInvitation = invitations?.find((inv) => inv.status === MemberStatus.Invited);
  if (pendingInvitation) {
    return <Navigate to={`/invitations/${pendingInvitation.id}`} />;
  }

  return <Outlet />;
}

export function ProtectedRoute() {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <PermissionProvider>
      <ProtectedContent />
    </PermissionProvider>
  );
}
